import React, { useEffect, useState } from 'react'
import { LIST_PREDICTIVEMAINTENANCE } from '../../../urls'
import { useAuth } from '../auth'
import './Reparationstyle.css'
import {
    KestirimSatiri,
    cubukGenisligi,
    kestirimSatirlari,
    sureBirimi,
    yuzdeMetni,
} from '../../../_elfaiotbbx/helpers/PredictiveRows'

type Props = {
    className: string
    uid: any
    deviceDescription: any
}

const PercentTable: React.FC<Props> = ({ className, uid, deviceDescription }) => {

    const { currentUser, logout } = useAuth()
    const token = currentUser?.token

    const [satirlar, setSatirlar] = useState<KestirimSatiri[]>([])
    const [durum, setDurum] = useState<'yukleniyor' | 'hazir' | 'hata'>('yukleniyor')
    const [hata, setHata] = useState<string | null>(null)

    const createHeader = () => {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', "" + token?.toString());
        return headers
    }

    /**
     * Onceden ne `ok` denetimi ne `catch` vardi: sunucu hata dondurdugunde
     * `response.json()` hata govdesini cozuyor ve sonuc dogrudan tabloya
     * yaziliyordu. Ekranda yalnizca BOS tablo goruluyordu -- "kayit yok" ile
     * "istek basarisiz" ayirt edilemiyordu.
     */
    async function getReparationList() {
        setDurum('yukleniyor')
        try {
            const response = await fetch(
                LIST_PREDICTIVEMAINTENANCE + `?uid=${uid}&startNumber=0&endNumber=10`,
                { method: "GET", headers: createHeader() }
            )
            if (response.status === 401) { logout(); return }
            if (response.status === 404) {
                // Bu cihaz icin kestirimci bakim kaydi yok: hata degil.
                setSatirlar([])
                setDurum('hazir')
                return
            }
            if (!response.ok) { throw new Error(`HTTP ${response.status}`) }

            const data = await response.json()
            setSatirlar(kestirimSatirlari(data))
            setHata(null)
            setDurum('hazir')
        } catch (e) {
            console.error("Kestirimci bakim listesi alinamadi:", e)
            setHata(e instanceof Error ? e.message : "bilinmeyen hata")
            setDurum('hata')
        }
    }

    /**
     * Eskiden tek seferlik bir kapi ve bir zamanlayici vardi:
     *
     *     if (pageInitialize == false) { getReparationList(); setTimeout(() => setPageInitialize(true), 1000) }
     *   }, [pageInitialize, tableInitialize])
     *
     * `getReparationList` basarili olunca `tableInitialize`'i yaziyor, effect
     * yeniden kosuyor ve kapi daha 1 saniye boyunca acik oldugu icin istek
     * IKINCI kez gidiyordu. Her acilista iki istek.
     */
    useEffect(() => {
        if (uid === undefined || uid === null || uid === '') {
            setDurum('hazir')
            setSatirlar([])
            return
        }
        getReparationList()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uid])

    return (
        <div className={`card ${className}`}>
            {/* begin::Header */}
            <div className='card-header border-0 pt-5'>
                <h3 className='card-title align-items-start flex-column'>
                    <span className='card-label fw-bold fs-3 mb-1'>{deviceDescription}</span>
                </h3>
            </div>
            {/* end::Header */}

            {/* begin::Body */}
            <div className='card-body py-3'>
                {/* Uc durum ARTIK AYRI. Oncesinde hepsi bos tabloydu. */}
                {!uid && (
                    <div className='text-muted'>
                        Cihaz seçilmedi. Bu tabloya Vinç Analiz listesindeki oktan geliniyor.
                    </div>
                )}

                {uid && durum === 'yukleniyor' && (
                    <div className='text-muted'>Yükleniyor…</div>
                )}

                {uid && durum === 'hata' && (
                    <div className='alert alert-danger'>
                        Kestirimci bakım listesi alınamadı{hata ? ` (${hata})` : ''}.
                    </div>
                )}

                {uid && durum === 'hazir' && satirlar.length === 0 && (
                    <div className='text-muted'>Bu cihaz için kayıtlı kart yok.</div>
                )}

                {uid && durum === 'hazir' && satirlar.length > 0 && (
                    <div className='table-responsive'>
                        <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                            <thead>
                                <tr className='fw-bold text-muted'>
                                    <th className='min-w-140px'>Açıklama</th>
                                    <th className='min-w-150px'>Input</th>
                                    <th className='min-w-140px'>Marka</th>
                                    <th className='min-w-140px'>Model</th>
                                    <th className='min-w-120px'>Tahmini kullanım</th>
                                    <th className='min-w-100px text-end'>Yaklaşık çalışma ömrü</th>
                                </tr>
                            </thead>
                            <tbody>
                                {satirlar.map((satir, index) => (
                                    <tr key={`${satir.input}-${index}`}>
                                        <td>
                                            <span className='text-dark fw-bold d-block fs-6 tooltiptext'
                                                style={{ width: '200px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                {satir.aciklama}
                                            </span>
                                        </td>
                                        <td>
                                            <span className='text-dark fw-bold fs-6'>{satir.input}</span>
                                        </td>
                                        <td>
                                            <span className='text-dark fw-bold d-block fs-6 tooltiptext'
                                                style={{ width: '200px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                {satir.marka}
                                            </span>
                                        </td>
                                        <td>
                                            <span className='text-dark fw-bold d-block fs-6 tooltiptext'
                                                style={{ width: '200px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                {satir.model}
                                            </span>
                                        </td>
                                        <td className='text-end'>
                                            <div className='d-flex flex-column w-100 me-2'>
                                                <div className='d-flex flex-stack mb-2'>
                                                    <span className='text-muted me-2 fs-7 fw-semibold'>
                                                        {yuzdeMetni(satir.yuzde)}
                                                    </span>
                                                </div>
                                                <div className='progress h-6px w-100'>
                                                    <div
                                                        className='progress-bar bg-primary'
                                                        role='progressbar'
                                                        style={{ width: cubukGenisligi(satir.yuzde) }}
                                                    ></div>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className='d-flex justify-content-end flex-shrink-0'>
                                                {satir.azamiSure === null
                                                    ? '-'
                                                    : satir.azamiSure + sureBirimi(satir.sureTipi)}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
            {/* end::Body */}
        </div>
    )
}

export { PercentTable }
